import { render, staticRenderFns } from "./GeographicalProduct.vue?vue&type=template&id=9f5c34a2&"
import script from "./GeographicalProduct.vue?vue&type=script&lang=js&"
export * from "./GeographicalProduct.vue?vue&type=script&lang=js&"
import style0 from "./GeographicalProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VContainer,VRow,VSimpleTable})
